import $ from 'jquery';

let elementIsVisible = function (target) {
    if ($(target)[0].getBoundingClientRect().top - $(window).height() < 0) {
        $('.modal[data-modal="rotation"]').css({'display' : 'none'});
    } else {
        $('.modal[data-modal="rotation"]').removeAttr('style');
    }
};

$(function () {
    let width = $(window).width();
    let height = $(window).height();
    let input = $('.page-form input[name="response[name]"]');

    window.onresize = function () {
        width = $(window).width();
        height = $(window).height();

        if (width >= height && width <= 560) {      //560px uses as maximum size of mobile devices
            window.addEventListener('touchend', function () {
                elementIsVisible(input);
            });
        }

        if (width >= height && width <= 560) {
                elementIsVisible(input)
        }
    };
});


